"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeaderLogoAndLinkBySegment = exports.createLogo = void 0;
const react_1 = __importDefault(require("react"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_components_icon_n_1 = __importDefault(require("@gerenciatd/next.components.icon-n"));
const constants_1 = require("../../constants");
const createLogo = ({ segment, logoInfo }) => {
    const svgIconClassLogoCss = `MovistarLogo${segment === constants_1.EMPRESAS ? ' TELogoDesktop' : ''}`;
    return (react_1.default.createElement(next_components_icon_n_1.default, { id: "Movistar", size: 44, color: "blue", className: svgIconClassLogoCss, segment: segment, kind: segment === constants_1.PARTICULARES ? 'S' : 'M' }));
    // return (
    //   <SvgIconLoader
    //     id={logoInfo.svgId}
    //     size={logoInfo.size}
    //     forceExternal
    //     color={logoInfo.color}
    //     className={svgIconClassLogoCss}
    //     layoutSize={logoInfo.layoutSize}
    //     segment={segment}
    //     kind={segment === PARTICULARES ? 'S' : 'M'}
    //   />
    // );
};
exports.createLogo = createLogo;
const getHeaderLogoAndLinkBySegment = ({ segment, logoInfo }) => {
    return (react_1.default.createElement("div", { className: "MovistarLogoGap" },
        react_1.default.createElement(next_components_custom_link_1.default, { href: "https://www.movistar.es", title: "Logo Movistar", ariaLabel: "ir a home", taggingInfo: {
                componentName: 'header',
                componentContent: 'LogoM',
                componentVariation: 'all',
                componentPerso: '',
                componentProduct: '',
            } }, (0, exports.createLogo)({ segment, logoInfo }))));
};
exports.getHeaderLogoAndLinkBySegment = getHeaderLogoAndLinkBySegment;
const HeaderLogo = ({ logoInfo, segment }) => {
    if (!logoInfo) {
        return null;
    }
    return (0, exports.getHeaderLogoAndLinkBySegment)({ logoInfo, segment: constants_1.PARTICULARES });
};
exports.default = HeaderLogo;
//# sourceMappingURL=index.js.map